export default {
    name: "GoHome",
    title: "Go Home Page",
    icon: "mdi-home-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
        };
    },
};